import { type DomainAccessControlConfig } from 'domains/insights-portal/utils/domain/accessControl'
import { Flipper } from 'domains/insights-portal/access-control/flippers'
import { Permission } from 'domains/insights-portal/access-control/permissions'

export const insightsPortalAdsCampaignAccessControl: DomainAccessControlConfig = [
  {
    flippers: Flipper.InsightsPortalAdsCampaign,
    permissions: Permission.Campaign,
  },
]
